import { Calls } from './Calls'
import { PastCalls } from './PastCalls'
import { Reports } from './Reports'
import { MessagesReport } from './MessagesReport'
import './messages-report.css'
import './reports-history.css'
import { can, canAny } from '../lib/api'

/** REPORTS / HISTORY (6 Oct 2026, at the customer's request): Past calls and
 *  Call log came off the top bar and sit here beside the two reports, so the
 *  top bar holds a shift's screens and this one tab holds everything that
 *  looks back.
 *
 *  NOTHING OPENS BY ITSELF. His words: "It should always ask you what you
 *  want to open up ... it should be blank in the middle." So every press of
 *  the tab lands on the question, and nothing is remembered between visits.
 *
 *  EACH BUTTON KEEPS ITS OWN TICK, exactly the gates the four top-bar doors
 *  had, so moving them here widened and narrowed nobody. The tab itself is
 *  drawn by `mayReportsHistory()` from the same four gates. */
export type HistoryPick = 'past' | 'log' | 'calls' | 'messages'

const mayPast = () => can('calls.past.review')
/** The screen only ever calls `POST /api/calls/search`. */
const mayLog = () => can('search.calls')
/** The Calls report draws the dashboard, the date-range tables, or both. */
const mayCallsReport = () =>
  can('reporting.dashboard') || can('reporting.export') || can('reporting.member_activity')
const mayMessages = () => can('reporting.messages')

export function mayReportsHistory(): boolean {
  return mayPast() || mayLog() || canAny('reporting')
}

export function ReportsHistory({ pick, onPick, pastCallId }: {
  /** Held by the Shell, so Search and Messaging can open a closed call here. */
  pick: HistoryPick | null
  onPick: (p: HistoryPick) => void
  pastCallId: string | null
}) {
  const btn = (p: HistoryPick, label: string) => (
    <button type="button" className={pick === p ? 'rh-on' : ''} aria-pressed={pick === p}
            onClick={() => onPick(p)}>{label}</button>
  )
  const history = mayPast() || mayLog()
  const reports = mayCallsReport() || mayMessages()

  return (
    <div className="rh-page">
      <div className="rh-bar" role="group" aria-label="Reports / History">
        {history && <span className="rh-grp">History</span>}
        {mayPast() && btn('past', 'Past calls')}
        {mayLog() && btn('log', 'Call log')}
        {history && reports && <span className="rh-sep" />}
        {reports && <span className="rh-grp">Reports</span>}
        {mayCallsReport() && btn('calls', 'Calls report')}
        {mayMessages() && btn('messages', 'Messages report')}
      </div>

      {pick === null && (
        <div className="rh-empty">
          <p>Please choose which report or history to open.</p>
        </div>
      )}
      {pick === 'past' && mayPast() && <PastCalls openId={pastCallId} />}
      {pick === 'log' && mayLog() && <Calls />}
      {pick === 'calls' && mayCallsReport() && <Reports />}
      {pick === 'messages' && mayMessages() && (
        <div className="workspace pad"><MessagesReport /></div>
      )}
    </div>
  )
}
